import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function uuid() {
  return crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
}
function getClientId() {
  const k = "analytics_client_id";
  let id = localStorage.getItem(k);
  if (!id) { id = uuid(); localStorage.setItem(k, id); }
  return id;
}
const SESSION_ID = uuid();

export default function usePageAnalytics({ apiUrl = "https://plataforma.aesop.health/api/api/analytics/page-view", minIntervalMs = 3000 }) {
  const location = useLocation();
  const lastSentRef = useRef({ path: null, ts: 0 });

  useEffect(() => {
    const path = location.pathname + location.search;
    const now = Date.now();
    if (lastSentRef.current.path === path && now - lastSentRef.current.ts < minIntervalMs) return;
    lastSentRef.current = { path, ts: now };

    const payload = {
      path,
      referrer: document.referrer || null,
      title: document.title || null,
      client_id: getClientId(),
      session_id: SESSION_ID,
      viewport_w: window.innerWidth,
      viewport_h: window.innerHeight,
      tz_offset_min: new Date().getTimezoneOffset(),
      occurred_at: new Date().toISOString(),
    };

    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    const sent = navigator.sendBeacon && navigator.sendBeacon(apiUrl, blob);
    if (!sent) {
      fetch(apiUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true, credentials: "omit" }).catch(()=>{});
    }
  }, [location, apiUrl, minIntervalMs]);
}
